'use strict'

angular.module('shiftTraderApp')
  .controller('OrganizationProfileCtrl', function ($scope, me, org, allPositions, regexStrings, $q, $timeout, $rootScope, $confirm,
                                                   ServerUrls, OrganizationSettings, UserPermissionsService, TimeService,
                                                   SubscriptionPlansService, UsersStore, TokenLedgers, Session, toastr,
                                                   $uibModal, TourService, Reports, ExternalIntegrations, CFA_LOCATION_IDENTIFIER_TYPE,
                                                   CFA_INTEGRATION_TYPE, initialTab) {
    var vm = this

    vm.me = me
    vm.org = org
    vm.allPositions = allPositions
    vm.regexStrings = regexStrings

    var stripe = Stripe(ServerUrls.current.stripeToken)
    var elements = stripe.elements()

    vm.datePickerOptions = {
      startingDay: null,
      showWeeks: false
    }

    $scope.$on('sa:organizationProfile:switchTab', function (evt, index) {
      vm.state.activeTab = index
    })

    vm.state = {
      activeTab: 0,
      rawPermissions: null,
      derivedPermissions: null,
      q: {
        canChangeEmail: function () { return vm.state.derivedPermissions.canChangeOrgConfig },
        canChangePhone: function () { return vm.state.derivedPermissions.canChangeOrgConfig },
        canChangeWebsite: function () { return vm.state.derivedPermissions.canChangeOrgConfig },
        canChangeOvertime: function () { return vm.state.derivedPermissions.canChangeOrgConfig },
        canChangeWorkWeek: function () { return vm.state.derivedPermissions.canChangeOrgConfig },
        canChangeAccountingStart: function () { return vm.state.derivedPermissions.canChangeOrgConfig },
        canChangeRateEstimate: function () { return vm.state.derivedPermissions.canChangeStartingPayRate },
        canChangeStartingPayRate: function () { return vm.state.derivedPermissions.canChangeOrgConfig },
        canEditDayOffPolicy: function () { return vm.state.derivedPermissions.canEditDayOffPolicy },
        canEditAvailabilityPolicy: function () { return vm.state.derivedPermissions.canEditAvailabilityPolicy },
        canPurchaseTokens: function () { return vm.state.derivedPermissions.canPurchaseTokens },
        canViewSubscriptionTab: function () { return vm.state.derivedPermissions.canViewSubscriptionTab },
        canViewSmsTokensTab: function () { return vm.state.derivedPermissions.canViewSmsTokensTab },
        canViewReportsTab: function () { return vm.state.derivedPermissions.canViewReportsTab },
        canViewIntegrationsTab: function () { return vm.state.derivedPermissions.canViewIntegrationsTab },
        canManageIntegrations: function () { return vm.state.derivedPermissions.canManageIntegrations },
        canViewSubscription: function () { return vm.state.derivedPermissions.canViewSubscription },
        canModifySubscription: function () { return vm.state.derivedPermissions.canModifySubscription },
        canViewCreditCard: function () { return vm.state.derivedPermissions.canViewCreditCard },
        canManageCreditCard: function () { return vm.state.derivedPermissions.canManageCreditCard },
        canViewAdvanced: function () { return vm.state.derivedPermissions.canViewAdvanced },
        canManageDepartmentsAndPositions: function () { return vm.state.derivedPermissions.canManageDepartmentsAndPositions },
        canCreatePositionAssignments: function () { return vm.state.derivedPermissions.canCreatePositionAssignments }
      }
    }

    var permissionsToLookUp = [
      'organization_configs.create',

      'days_off.edit_policy',
      'availability_sets.edit_policy',

      'token_ledgers.buy_tokens',

      'organizations.modify_subscription',
      'organizations.view_subscription',
      'organizations.view_integrations',
      'organizations.manage_integrations',
      'credit_cards.view',
      'credit_cards.manage',

      'ui.organization.view_advanced_settings',

      'positions.create',
      'positions.set_inactive',
      'positions.update',

      'departments.create',
      'departments.set_inactive',
      'departments.update',

      'users_positions.create',
      'users_positions.set_inactive',

      'user_pay_rates.view',

      'reports.employees',
      'reports.weekly_hours',
      'reports.store_announcements',
      'reports.cfa_team_members_export',
    ]

    var promises = [
      UserPermissionsService.getCanDict(permissionsToLookUp, vm.org.id),
    ]

    $q.all(promises)
      .then(function (results) {
        vm.state.rawPermissions = results[0]

        processRawPermissions()

        // Tab viewing is dependent on the permissions
        setupTabs()
      })

    function processRawPermissions() {
      var rawPerm = vm.state.rawPermissions

      vm.state.derivedPermissions = {
        canChangeOrgConfig: rawPerm['organization_configs.create'],
        canChangeStartingPayRate: rawPerm['user_pay_rates.view'],
        canEditDayOffPolicy: rawPerm['days_off.edit_policy'],
        canEditAvailabilityPolicy: rawPerm['availability_sets.edit_policy'],
        canPurchaseTokens: rawPerm['token_ledgers.buy_tokens'],
        canViewSubscriptionTab: rawPerm['organizations.view_subscription'] || rawPerm['organizations.edit_subscription'] || rawPerm['credit_cards.view'] || rawPerm['credit_cards.manage'],
        canViewSmsTokensTab: rawPerm['token_ledgers.buy_tokens'],
        canViewReportsTab: rawPerm['reports.employees'] && rawPerm['reports.weekly_hours'] && rawPerm['reports.store_announcements'],
        canViewIntegrationsTab: rawPerm['organizations.view_integrations'],
        canManageIntegrations: rawPerm['organizations.manage_integrations'],
        canViewSubscription: rawPerm['organizations.view_subscription'],
        canModifySubscription: rawPerm['organizations.modify_subscription'],
        canViewCreditCard: rawPerm['credit_cards.view'],
        canManageCreditCard: rawPerm['credit_cards.manage'],
        canViewAdvanced: rawPerm['ui.organization.view_advanced_settings'],
        canManageDepartmentsAndPositions: rawPerm['positions.create'] && rawPerm['positions.set_inactive'] &&
          rawPerm['positions.update'] && rawPerm['departments.create'] && rawPerm['departments.set_inactive'] && rawPerm['departments.update'],
        canCreatePositionAssignments: rawPerm['users_positions.create'] && rawPerm['users_positions.set_inactive']
      }
    }

    function setupTabs() {
      vm.tabs = [
        { title: 'Settings',          template: 'views/organizationProfile/tabs/settingsTab.html',          show: true, link: 'settings' },
        { title: 'Depts & Positions', template: 'views/organizationProfile/tabs/positionsTab.html',         show: vm.state.q.canManageDepartmentsAndPositions(), link: 'positions' },
        { title: 'Assign Positions',  template: 'views/organizationProfile/tabs/massUserPositionsTab.html', show: vm.state.q.canCreatePositionAssignments(), link: 'assignPositions' },
        { title: 'Policies',          template: 'views/organizationProfile/tabs/policiesTab.html',          show: true, link: 'policies' },
        { title: 'Subscription',      template: 'views/organizationProfile/tabs/subscriptionTab.html',      show: vm.state.q.canViewSubscriptionTab(), link: 'subscription' },
        { title: 'SMS Tokens',        template: 'views/organizationProfile/tabs/smsTokensTab.html',         show: vm.state.q.canViewSmsTokensTab(), link: 'smsTokens' },
        { title: 'Reports',           template: 'views/organizationProfile/tabs/reportsTab.html',           show: vm.state.q.canViewReportsTab(), link:'reports' },
        { title: 'Integrations',      template: 'views/organizationProfile/tabs/integrationsTab.html',      show: vm.state.q.canViewIntegrationsTab(), link: 'integrations' },
      ]

      if (vm.me.$isAdmin() && _.isNull(vm.org.organization_config.onboarding_wizard_completed_at) && vm.org.id >= 25 && !vm.org.$isInSandboxMode()) {
        vm.openWizardModal()
      } else if (vm.me.$isAdmin() && !lodash.has(vm.me.completed_tours, 'org-profile-tour') && !((vm.org.$isInSandboxMode() || vm.org.$isInTrialMode()) && vm.org.organization_config.demo_state !== 'done')) {
        $timeout(function () { TourService.startTour('org-profile-tour') }, 1500)
      }

      vm.settings.initTab();

      if (vm.state.q.canCreatePositionAssignments()) {
        vm.assignPositions.initTab()
      }

      if (vm.state.q.canViewSmsTokensTab()) {
        vm.smsTokens.initTab()
      }

      if (vm.state.q.canViewSubscriptionTab()) {
        vm.subscriptionTab.initTab()
      }

      if (vm.state.q.canViewIntegrationsTab()) {
        vm.integrationsTab.initTab()
      }

      vm.state.activeTab = initialTab
       ? vm.tabs.findIndex(function (tab) { return tab.link === initialTab })
       : 0
    }

    vm.settings = {
      initTab: function () {
        vm.daySettingMapping = [{
          name: 'Sunday',
          value: 0
        }, {
          name: 'Monday',
          value: 1
        }, {
          name: 'Tuesday',
          value: 2
        }, {
          name: 'Wednesday',
          value: 3
        }, {
          name: 'Thursday',
          value: 4
        }, {
          name: 'Friday',
          value: 5
        }, {
          name: 'Saturday',
          value: 6
        }]

        vm.dayHourStart = [{
          name: '12:00am',
          value: 0
        }, {
          name: '1:00am',
          value: 1
        }, {
          name: '2:00am',
          value: 2
        }, {
          name: '3:00am',
          value: 3
        }, {
          name: '4:00am',
          value: 4
        }, {
          name: '5:00am',
          value: 5
        }, {
          name: '6:00am',
          value: 6
        }]
      },
      containers: {
        overtime: {
          editing: false,
          updateFields: {
            overtimeThreshold: vm.org.organization_config.overtime_threshold_hours,
            penalizeGreater: vm.org.organization_config.penalize_target_gt_overtime
          },
          update: function () {
            var fields = vm.settings.containers.overtime.updateFields

            var payload = {}
            if (fields.overtimeThreshold !== vm.org.organization_config.overtime_threshold_hours) {
              payload.overtime_threshold_hours = fields.overtimeThreshold
            }

            // If ng-pattern is invalid, the value will be undefined. We
            // should reset the value to the original it had.
            if (!fields.overtimeThreshold) {
              vm.settings.containers.overtime.updateFields.overtimeThreshold = vm.org.organization_config.overtime_threshold_hours
            }

            if (!lodash.isEmpty(payload)) {
              lodash.each(payload, function (value, key) {
                vm.org.organization_config[key] = value
              })

              OrganizationSettings.create(vm.org.organization_config)
                .then(function (org_config) {
                  vm.org.organization_config = org_config
                })
            }
          },
          canEdit: function () {
            return vm.state.q.canChangeOvertime()
          }
        },
        contact: {
          editing: false,
          updateFields: {
            email: vm.org.organization_config.email,
            phone: vm.org.organization_config.phone_number,
            website: vm.org.organization_config.fb_url
          },
          update: function () {
            var fields = vm.settings.containers.contact.updateFields

            var payload = {}
            if (fields.email !== vm.org.organization_config.email) {
              payload.email = fields.email
            }
            if (fields.phone !== vm.org.organization_config.phone_number) {
              payload.phone_number = fields.phone
            }
            if (fields.website !== vm.org.organization_config.fb_url) {
              payload.fb_url = fields.website
            }

            // If ng-pattern is invalid, the value will be undefined. We
            // should reset the value to the original it had.
            if (!fields.email) {
              vm.settings.containers.contact.updateFields.email = vm.org.organization_config.email
            }
            if (!fields.phone) {
              vm.settings.containers.contact.updateFields.phone = vm.org.organization_config.phone_number
            }

            if (!lodash.isEmpty(payload)) {
              lodash.each(payload, function (value, key) {
                vm.org.organization_config[key] = value
              })

              OrganizationSettings.create(vm.org.organization_config)
                .then(function (org_config) {
                  vm.org.organization_config = org_config
                })
            }
          },
          canEdit: function () {
            return vm.state.q.canChangeEmail() || vm.state.q.canChangePhone()
          }
        },
        calendar: {}, // not necessary at this point in time
        other: {
          editing: false,
          updateFields: {
            rateEstimate: vm.org.organization_config.hourly_rate_for_estimates,
            startingPayRate: vm.org.organization_config.starting_pay_rate
          },
          update: function () {
            var fields = vm.settings.containers.other.updateFields

            var payload = {}
            if (fields.rateEstimate !== vm.org.organization_config.hourly_rate_for_estimates) {
              payload.hourly_rate_for_estimates = fields.rateEstimate
            }
            if (fields.startingPayRate !== vm.org.organization_config.starting_pay_rate) {
              payload.starting_pay_rate = fields.startingPayRate
            }

            if (!lodash.isEmpty(payload)) {
              lodash.each(payload, function (value, key) {
                vm.org.organization_config[key] = value
              })

              OrganizationSettings.create(vm.org.organization_config)
                .then(function (org_config) {
                  vm.org.organization_config = org_config
                })
            }
          },
          canEdit: function () {
            return vm.state.q.canChangeRateEstimate() || vm.state.q.canChangeStartingPayRate()
          }
        }
      }
    }

    vm.assignPositions = {
      initTab: function () {
        var promises = []
        promises.push(UsersStore.getAll())

        $q.all(promises)
          .then(function (results) {
            vm.assignPositions.state.allUsers = results[0]
          })
      },
      state: {
        allUsers: null
      }
    }


    vm.smsTokens = {
      initTab: function () {
        var promises = []

        if (vm.state.q.canPurchaseTokens()) {
          promises.push(TokenLedgers.getCurrentTokens(vm.org.id))
          promises.push(TokenLedgers.getPlans())
        }

        $q.all(promises)
          .then(function (results) {
            if (vm.state.q.canPurchaseTokens()) {
              vm.smsTokens.state.currentSmsTokens = results[0]
              vm.smsTokens.state.plans = results[1]
            }
          })
      },
      state: {
        currentSmsTokens: null,
        purchasingTokens: false,
        plans: null,
        selectedPlan: null,
        processingPurchase: false
      },
      selectPlan: function (plan) {
        vm.smsTokens.state.selectedPlan = plan
      },
      purchaseTokens: function () {
        vm.smsTokens.state.processingPurchase = true
        TokenLedgers.purchaseTokens(vm.org.id, vm.smsTokens.state.selectedPlan.id)
          .then(function () {
            vm.smsTokens.state.currentSmsTokens += vm.smsTokens.state.selectedPlan.credits

            toastr.success('Purchased ' + vm.smsTokens.state.selectedPlan.credits + ' SMS Tokens', 'Success')
            vm.smsTokens.state.processingPurchase = false
            vm.smsTokens.state.purchasingTokens = false
          }, function () {
            vm.smsTokens.state.processingPurchase = false
          })
      },
      commaSeparatedNumber: function (val) {
        if (val) {
          while (/(\d+)(\d{3})/.test(val.toString())) {
            val = val.toString().replace(/(\d+)(\d{3})/, '$1'+','+'$2')
          }
        }
        return val
      }
    }

    vm.subscriptionTab = {
      initTab: function () {
        var promises = []
        if (vm.state.q.canViewSubscription()) {
          promises.push(SubscriptionPlansService.getPlans('v3'))
          promises.push(vm.org.getSubscriptions())
        }

        promises.push(UsersStore.getAll())

        if (vm.state.q.canViewCreditCard()) {
          promises.push(vm.org.getCreditCard())
        }

        $q.all(promises)
          .then(function (results) {
            if (vm.state.q.canViewSubscription()) {
              vm.subscriptionTab.state.allPlans = results[0]
              vm.subscriptionTab.state.currentSubscription = lodash.last(lodash.sortBy(results[1], 'start'))
              vm.subscriptionTab.state.currentPlan = lodash.find(vm.subscriptionTab.state.allPlans, { id: vm.subscriptionTab.state.currentSubscription.plan.id })
              vm.subscriptionTab.state.queuedPlanType = vm.org.queued_plan_type

              vm.subscriptionTab.state.numEmployees = results[2].length

              // Figure out which plans are relevant to the organization.
              // This means find the plans that are for the number of employees the
              // organization has.
              vm.subscriptionTab.filterPlans()

              if (vm.state.q.canViewCreditCard()) {
                vm.subscriptionTab.state.creditCard = lodash.first(results[3])
              }
            } else {
              vm.subscriptionTab.state.numEmployees = results[0].length

              if (vm.state.q.canViewCreditCard()) {
                vm.subscriptionTab.state.creditCard = lodash.first(results[1])
              }
            }

            vm.subscriptionTab.state.loadingTab = false
            // Hide the loading shade so you can click through to the current sub container
            $timeout(function () { $('.loading-shade').hide() }, 500)
          })
      },
      state: {
        loadingTab: true,
        allPlans: null,
        currentSubscription: null,
        currentPlan: null,
        numEmployees: null,
        selectedPlanId: null,
        queuedPlanType: null,
        relevantPlans: { /* ... */ },
        processingSubscriptionChange: false,
        changingCreditCard: false,
        isInDemo: vm.org.$isInSandboxMode(),
        isInTrial: vm.org.$isInTrialMode(),
        q: {
          showCancelButton: function () {
            var sub = vm.subscriptionTab.state.currentSubscription
            return (sub.$isInTrialPeriod() && !sub.cancel_at_period_end) ||
                   (sub.$isActive() && vm.state.q.canModifySubscription())
          },
          getCurrentPlanName: function() {
            if (vm.subscriptionTab.state.isInDemo) {
              return 'DEMO';
            } else {
              if (vm.subscriptionTab.state.currentPlan) {
                return vm.subscriptionTab.state.currentPlan.plan_type;
              } else {
                return '';
              }
            }
          }
        }
      },
      filterPlans: function () {
        var numEmployees = vm.subscriptionTab.state.numEmployees

        var monthlyPlans = lodash.filter(vm.subscriptionTab.state.allPlans, { interval: 'month' })

        // Basic is the same no matter how many employees they have
        vm.subscriptionTab.state.relevantPlans.basic = lodash.find(vm.subscriptionTab.state.allPlans, function(plan) {
          return plan.id === 'SA-BASIC'
        })

        if (numEmployees == 0) {
          vm.subscriptionTab.state.relevantPlans.team = lodash.find(monthlyPlans, function(plan) {
            return plan.plan_type === 'TEAM' && lodash.inRange(1, plan.num_emp_start, plan.num_emp_end + 1)
          })
          vm.subscriptionTab.state.relevantPlans.plus = lodash.find(monthlyPlans, function(plan) {
            return plan.plan_type === 'PLUS' && lodash.inRange(1, plan.num_emp_start, plan.num_emp_end + 1)
          })
        } else if (numEmployees > 199) {
          vm.subscriptionTab.state.relevantPlans.team = lodash.find(monthlyPlans, function(plan) {
            return plan.plan_type === 'TEAM' && lodash.inRange(199, plan.num_emp_start, plan.num_emp_end + 1)
          })
          vm.subscriptionTab.state.relevantPlans.plus = lodash.find(monthlyPlans, function(plan) {
            return plan.plan_type === 'PLUS' && lodash.inRange(199, plan.num_emp_start, plan.num_emp_end + 1)
          })
        } else {
          // Most common case
          // Show them the plans based on the number they entered for their employee number
          vm.subscriptionTab.state.relevantPlans.team = lodash.find(monthlyPlans, function(plan) {
            return plan.plan_type === 'TEAM' && lodash.inRange(numEmployees, plan.num_emp_start, plan.num_emp_end + 1)
          })
          vm.subscriptionTab.state.relevantPlans.plus = lodash.find(monthlyPlans, function(plan) {
            return plan.plan_type === 'PLUS' && lodash.inRange(numEmployees, plan.num_emp_start, plan.num_emp_end + 1)
          })
        }

        vm.subscriptionTab.state.relevantPlans.basic._description = 'Shift Agent Basic allows you to use the powerful scheduling tool, but only one account is allowed to log in and make the schedule.'
        vm.subscriptionTab.state.relevantPlans.team._description = 'Shift Agent Team allows your entire team to utilize the power of the platform by allowing them to interact with the schedule you make.'
        vm.subscriptionTab.state.relevantPlans.plus._description = 'Shift Agent Plus give you all of the great features of Team, but also allows you to utilize the new and powerful Notes system.'
      },
      openSubscriptionEditor: function () {
        var statusHeight = $('.status-indicator').height() + $('.current-subscription').height() + 100

        // Transition the out-container out of the visible container.
        $('.current-subscription').css({'top': '-' + statusHeight + 'px'})
        $timeout(function () {
          $('.current-subscription').css({'display': 'none'})
        }, 500)

        // Must set the in-container to position -> absolute to remove it from the
        // DOM flow. This prevents the wrapping container from changing size instantly
        // when the element is placed into the DOM with display -> flex.
        //
        // It will be set back to position -> relative after the animation completes.
        $('.subscription-editor').css({'position': 'absolute', 'display': 'flex'})

        var editorHeight = $('.subscription-editor').height()
        $timeout(function () {
          // We won't want a delay on the height transition of the wrapping container
          // all the time, so we add it here and remove it after the animation.
          $('.movement-relative').css('transition-delay', '0.25s')

          // Set the wrapping containers height and have it transition to the appropriate
          // height before we add the desired element back into the DOM flow.
          $('.movement-relative').height(editorHeight)

          // Trigger the main animation and add the element back to the DOM flow.
          $('.subscription-editor').css({top: '0', opacity: 1, position: 'relative'})

          // Remove the wrapping containers height animation delay.
          $timeout(function () {
            $('.movement-relative').css('transition-delay', '0s')
          }, 250)
        }, 50)
      },
      closeSubscriptionEditor: function () {
        var viewHeight = $('.current-subscription').height()

        // Move the currently visible container back down and begin to fade it out.
        $('.subscription-editor').css({top: (viewHeight + 50) + 'px', opacity: 0, position: 'relative', 'transition-delay': '0s'})

        // Begin to animate the resize of the wrapping container.
        $('.movement-relative').height(viewHeight)

        $timeout(function () {
          // Reshow the new container (off-screen) and set position -> absolute
          // so the DOM doesn't resize too quickly.
          $('.current-subscription').css({'display': 'block', 'position': 'absolute'})

          // Bring the new container back into the DOM flow with position -> relative
          // and begin the animation to bring it back down.
          $timeout(function () {
            $('.current-subscription').css({'position': 'relative', 'top': '0'})
            $('.subscription-editor').css('transition-delay', '0.25s')
            vm.subscriptionTab.reset()
          }, 250)
        }, 50)
      },
      selectPlanChange: function (plan) {
        vm.subscriptionTab.state.selectedPlan = plan
      },
      submitChangePlan: function () {
        vm.subscriptionTab.state.processingSubscriptionChange = true

        var selected = vm.subscriptionTab.state.selectedPlan
        vm.org.$updatePlan(selected.plan_type, selected.id)
          .then(function (updatedOrg) {
            vm.org = updatedOrg
            toastr.success('We have successfully queued your plan change.', 'Plan Changed')

            Session.getCurrentOrg(true)
            vm.subscriptionTab.state.queuedPlanType = vm.org.queued_plan_type
            $timeout(function () {
              vm.subscriptionTab.closeSubscriptionEditor()
              if (vm.org.$isInTrialMode()) {
                $rootScope.$broadcast('sa:demoTour:refreshBar');
              }
            }, 250)
          }, function (response) {

          })
      },
      cancelQueuedPlanChange: function (evt) {
        evt.preventDefault()
        evt.stopPropagation()

        // In order to cancel the queued change, you can simply change the plan
        // back to the one you currently have and the API will clear the queued_plan_type
        // field on the Organization model.
        var current = vm.subscriptionTab.state.currentPlan
        vm.org.$updatePlan(current.plan_type, current.id)
          .then(function (updatedOrg) {
            vm.org = updatedOrg
            toastr.success('We have cancelled your plan change. Your plan will remain as it currently is.', 'Cancel Plan Change')

            Session.getCurrentOrg(true)
            $('.queued > .top-header').css('opacity', '0')
            $timeout(function () {
              vm.subscriptionTab.state.queuedPlanType = null
              $('.queued > .top-header').removeAttr('style')
            }, 500)
            $timeout(function () {
              vm.subscriptionTab.closeSubscriptionEditor()
              if (vm.org.$isInTrialMode()) {
                $rootScope.$broadcast('sa:demoTour:refreshBar');
              }
            }, 250)
          }, function (response) {

          })
      },
      reset: function () {
        vm.subscriptionTab.state.processingSubscriptionChange = false
        vm.subscriptionTab.state.selectedPlan = null
      },
      cancelSubscription: function () {
        $confirm({
          title: 'Cancel your subscription?',
          text: 'Are you sure that you would like to cancel your subscription to Shift Agent?',
          ok: 'Yes, please.',
          cancel: 'No, don\'t cancel.'
        }).then(function () {
          // When we cancel the subscription, we simply just transfer to the FREE plan.
          var basicPlan = vm.subscriptionTab.state.relevantPlans.basic
          vm.org.$updatePlan(basicPlan.plan_type, basicPlan.id)
            .then(function (updatedOrg) {
              vm.org = updatedOrg
              toastr.success('Your subscription will be switched to the BASIC plan at the conclusion of the current billing cycle; you will not be charged. We are sorry to see you go.', 'Plan Cancelled')

              Session.getCurrentOrg(true)
              vm.subscriptionTab.state.queuedPlanType = vm.org.queued_plan_type
              $timeout(function () {
                vm.subscriptionTab.closeSubscriptionEditor()
                if (vm.org.$isInTrialMode()) {
                  $rootScope.$broadcast('sa:demoTour:refreshBar');
                }
              }, 250)
          })
        })
      },
      createCardToken: function () {
        vm.subscriptionTab.state.creatingCreditCard = true
        var form = document.querySelector('.credit-card-entry-container')
        var extraDetails = {
          name: form.querySelector('input[name=cardholder-name]').value
        }

        stripe.createToken(vm.subscriptionTab.state.card, extraDetails)
          .then(function (result) {
            if (result.error) {
              var errorElement = $('#card-errors')
              errorElement.text(result.error.message)
              toastr.error('Your card entry contains errors. Please verify the information you entered.', 'Invalid Payment Details')
            } else {
              vm.org.createCreditCard(result.token.id)
                .then(function (stripeData) {
                  vm.subscriptionTab.state.creditCard = stripeData
                  vm.subscriptionTab.state.creatingCreditCard = false
                  vm.subscriptionTab.state.changingCreditCard = false
                  toastr.success('We have successfully updated your payment method.', 'Updated Payment Method')
                })
            }
          })
      },
      removeCreditCard: function () {
        $confirm({
          title: 'Remove your credit card?',
          text: 'Are you sure that you would like to remove this credit card from your account?',
          ok: 'Yes, remove it',
          cancel: 'No, don\'t remove it'
        }).then(function () {
          vm.org.deleteCreditCard(vm.subscriptionTab.state.creditCard.id)
            .then(function () {
              vm.subscriptionTab.state.creditCard = null
              toastr.success('Successfully removed your credit card.', 'Removed Credit Card')
            }, function (response) {
              toastr.error('Failed to remove credit card.', 'Error Removing Card')
            })
        })
      },
      toggleChangeCreditCard: function (state) {
        if (state) {
          if (vm.subscriptionTab.state.card) {
            vm.subscriptionTab.state.card.unmount()
          } else {
            vm.subscriptionTab.state.card = elements.create('card', {
              iconStyle: 'solid',
              style: {
                base: {
                  color: 'gray',
                  fontSize: '1.6rem',
                  '::placeholder': {
                    color: '#c8c8c8'
                  }
                },
                invalid: {
                  iconColor: '#a73434',
                  color: '#a73434'
                }
              }
            })
          }
          $timeout(function () {
            vm.subscriptionTab.state.card.mount('#card-element')
          }, 50)
        }
        vm.subscriptionTab.state.changingCreditCard = state
      },
      openInvoiceModal: function () {
        var modalInstance = $uibModal.open({
          size: 'md2',
          templateUrl: 'views/organizationProfile/invoiceModal.html',
          controller: 'InvoiceModalCtrl',
          controllerAs: 'invoiceModal',
          resolve: {
            org: ['Organizations', function(Organizations) {
              return Organizations.getCurrentOrg()
            }]
          }
        })
      }
    }

    vm.reportsTab = {
      state: {
        selectedReport: null,
        datepickerOpens: {},
        reportInputs: {
          'weekly-hours': {
            start_date: TimeService.getWeekTwixFromMoment(TimeService.getBeginningOfDayFromDate(new Date).subtract(7, 'days')).start.add(12, 'hours').toDate()
          },
          'analyze-days-off': {
            start_date: TimeService.getBeginningOfDayFromDate(new Date).subtract(3, 'months').add(12, 'hours').toDate()
          },
          'analyze-trades': {
            start_date: TimeService.getBeginningOfDayFromDate(new Date).subtract(3, 'months').add(12, 'hours').toDate()
          },
          'adp-csv-export': {
            start_date: TimeService.getBeginningOfDayFromDate(new Date).subtract(7, 'days').add(12, 'hours').toDate(),
            end_date: TimeService.getBeginningOfDayFromDate(new Date).add(12, 'hours').toDate()
          }
        }
      },
      initTab: function () {

      },
      toggleDatepicker: function (datepicker) {
        console.log('TOGGLING', datepicker)
        if (vm.reportsTab.state.datepickerOpens[datepicker] === undefined) {
          console.log('Generating', datepicker)
          vm.reportsTab.state.datepickerOpens[datepicker] = true
        } else {
          vm.reportsTab.state.datepickerOpens[datepicker] = !vm.reportsTab.state.datepickerOpens[datepicker]
        }
      },
      selectReport: function (report) {
        var selectedReport = vm.reportsTab.state.selectedReport
        if (selectedReport === report) return
        if (selectedReport) {
          $('.reports-tab .profile-content-container.' + selectedReport).addClass('hide')
        }

        selectedReport = report
        $('.reports-tab .profile-content-container.' + selectedReport).removeClass('hide')

        vm.reportsTab.state.selectedReport = report
      },
      reportUrl: function () {
        var extraParams = {
          access_token: Session.getAccessToken(),
          organization_id: vm.org.id
        }
        return Reports.buildReportUrl(vm.reportsTab.state.selectedReport, vm.reportsTab.state.reportInputs, extraParams)
      }
    }

    vm.integrationsTab = {
      state: {
        cfaIntegration: {},
      },
      initTab: function () {
        var integrationRecord = org.external_integrations && _.find(org.external_integrations, { type: CFA_INTEGRATION_TYPE })
        var locationIdentifier = org.external_identifiers && _.find(org.external_identifiers, { type: CFA_LOCATION_IDENTIFIER_TYPE })
        vm.integrationsTab.state.cfaIntegration = {
          enabled: integrationRecord ? integrationRecord.active : false,
          authed: !!integrationRecord,
          showPrimary: !!integrationRecord && !!locationIdentifier,
          integration: integrationRecord,
          locationIdentifier: locationIdentifier,
          lastSyncedAt: integrationRecord && integrationRecord.data.last_synced_at && locationIdentifier && moment(integrationRecord.data.last_synced_at).format('MM/DD/YY @ hh:mm:ss'),
          showLocationSelector: integrationRecord && !locationIdentifier,
          loginUrl: ServerUrls.current.railsApi + 'external_integrations/cfa/login?organization_id=' + vm.org.id + '&access_token=' + Session.getAccessToken(),
          locationNums: integrationRecord ? _(['']).concat(integrationRecord.data['cfa_locations']).value() : [],
          selectedLocation: '',
          refreshOrg: function () {
            return Session.getCurrentOrg(true)
              .then(function (org) {
                vm.org = org
                var integrationRecord = org.external_integrations.length > 0 && _.find(org.external_integrations, { type: CFA_INTEGRATION_TYPE })
                var locationIdent = org.external_identifiers.length > 0 && _.find(org.external_identifiers, { type: CFA_LOCATION_IDENTIFIER_TYPE })
                vm.integrationsTab.state.cfaIntegration.integration = integrationRecord
                vm.integrationsTab.state.cfaIntegration.locationIdentifier = locationIdent
                return org
              })
          },
          setLocation: function (num) {
            $confirm({
              title: 'Setting Store #',
              text: 'You are about to set your store number to ' + vm.integrationsTab.state.cfaIntegration.selectedLocation + '. Proceed?',
              ok: 'Yes',
              cancel: 'Cancel'
            }).then(function () {
              var payload = {
                id: integrationRecord.id,
                identifiers: {},
              }
              payload.identifiers[CFA_LOCATION_IDENTIFIER_TYPE] = vm.integrationsTab.state.cfaIntegration.selectedLocation
              ExternalIntegrations.update(payload)
                .then(vm.integrationsTab.state.cfaIntegration.refreshOrg)
                .then(function (org) {
                  var locationIdent = _.find(org.external_identifiers, { type: CFA_LOCATION_IDENTIFIER_TYPE })
                  vm.integrationsTab.state.cfaIntegration.showPrimary = vm.integrationsTab.state.cfaIntegration.authed && locationIdent
                  vm.integrationsTab.state.cfaIntegration.showLocationSelector = !locationIdent
                })
            }, function () {})
          },
          sync: function () {
            ExternalIntegrations.sync(vm.integrationsTab.state.cfaIntegration.integration.id)
              .then(vm.integrationsTab.state.cfaIntegration.refreshOrg)
              .then(function () {
                toastr.success('Shift Agent is about to start syncing your records. Refresh the page in 1 to 2 minutes to see results.', 'Success.')
                // vm.integrationsTab.state.cfaIntegration.lastSyncedAt = moment(vm.integrationsTab.state.cfaIntegration.integration.data.last_synced_at).format('MM/DD/YY @ hh:mm:ss')
              })
          },
        }

        var initializingWatch = true
        $scope.$watch('orgProfileCtrl.integrationsTab.state.cfaIntegration.enabled', function (newVal, oldVal) {
          if (initializingWatch) {
            initializingWatch = false
            return
          }

          function perform () {
            var payload = { id: integrationRecord.id }
            if (newVal) {
              payload.active = true
            } else if (!newVal && oldVal) {
              payload.active = false
            }
            return ExternalIntegrations.update(payload)
              .then(vm.integrationsTab.state.cfaIntegration.refreshOrg)
          }

          var integrationRecord = vm.integrationsTab.state.cfaIntegration.integration
          if (integrationRecord && newVal === false && oldVal !== undefined) {
            $confirm({
              title: 'Disable CFA Integration',
              text: 'Are you sure you want to disable your integration with CFA Home?',
              ok: 'Yes',
              cancel: 'Cancel'
            }).then(perform, function () {
              vm.integrationsTab.state.cfaIntegration.enabled = true
            })
          } else if (integrationRecord && newVal) {
            perform()
          }
        })
      },
      downloadTeamMembersExportUrl: function () {
        const extraParams = {
          access_token: Session.getAccessToken(),
          organization_id: vm.org.id
        }
        return Reports.buildReportUrl('cfa-team-members-export', {}, extraParams)
      }
    }

    vm.canEdit = function(tab, container) {
      return vm[tab].containers[container].canEdit()
    }

    vm.processContainer = function(tab, container, forceOption) {
      if (forceOption === 'close' || (vm[tab].containers[container].editing && forceOption !== 'open')) {
        vm[tab].containers[container].update()
      }

      vm[tab].containers[container].editing = !vm[tab].containers[container].editing
    }

    vm.openWizardModal = function() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/organizationSetupWizard.html',
        controller: 'OrganizationSetupWizardCtrl',
        size: 'wizard',
        keyboard: false,
        backdrop: 'static',
        resolve: {
          params: function() {
            return {
              me: vm.me,
              org: vm.org,
              allPositions: vm.allPositions
            };
          },
          allUsers: ['UsersStore', function (UsersStore) {
            return UsersStore.getAll();
          }]
        }
      });
      modalInstance.result.then(function(result) {
          console.log('closed explanation of setup with result' + result);
        },
        function(reason) {
          console.log('dismissed explanation with reason ' + reason);
        })
    }
  })
